import React, { useEffect, useId, useRef, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import useMobileLayout from './useMobileLayout';

// Keep the next action nearby on phones without shortening the desktop introduction.
export default function MobileSummary({ children, className = '' }) {
  const { language } = useLanguage();
  const mobile = useMobileLayout();
  const id = useId();
  const paragraph = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [overflows, setOverflows] = useState(false);
  useEffect(() => { setExpanded(false); }, [children, mobile]);
  useEffect(() => {
    const element = paragraph.current;
    if (!element || !mobile) return undefined;
    const measure = () => setOverflows(element.scrollHeight > parseFloat(getComputedStyle(element).lineHeight) * 4 + 2);
    measure();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    observer?.observe(element);
    return () => observer?.disconnect();
  }, [children, mobile]);
  return <div className="js-mobile-summary">
    <p id={id} ref={paragraph} dir="auto" className={`${className} ${mobile && !expanded ? 'js-mobile-summary__clamped' : ''}`}>{children}</p>
    {mobile && overflows && <button type="button" className="js-mobile-summary__toggle" aria-expanded={expanded} aria-controls={id} onClick={() => setExpanded(value => !value)}>
      {language === 'ar' ? (expanded ? 'عرض أقل' : 'اقرأ المزيد') : (expanded ? 'Show less' : 'Read more')}
    </button>}
  </div>;
}
